import { Controller } from "@hotwired/stimulus"

export default class extends Controller {

    static targets = ['input', 'increase', 'decrease']

    connect() {
        this.processQuantityUpdate(this.inputTarget.value);
    }

    validatePositive(event) {
        event.target.value = event.target.value.replace(/[^0-9.]/g, '')
        const value = parseFloat(event.target.value)

        if (value < 0 || isNaN(value)) {
            event.target.value = 0;
        }

        const max = isNaN(parseFloat(this.inputTarget.max)) ? Infinity : parseFloat(this.inputTarget.max)

        if (value > max) {
            event.target.value = max;
        }

        this.processQuantityUpdate(event.target.value)
    }

    increaseQuantity(e) {
        e.preventDefault()
        e.stopImmediatePropagation()

        const max = isNaN(parseFloat(this.inputTarget.max)) ? Infinity : parseFloat(this.inputTarget.max)

        const oldQuantity = parseInt(this.inputTarget.value)
        const newQuantity = Math.min(oldQuantity + 1, max)

        this.processQuantityUpdate(newQuantity)
    }

    decreaseQuantity(e) {
        e.preventDefault()
        e.stopImmediatePropagation()

        const min = isNaN(parseFloat(this.inputTarget.min)) ? -Infinity : parseFloat(this.inputTarget.min)

        const oldQuantity = parseInt(this.inputTarget.value)
        const newQuantity = Math.max(oldQuantity - 1, min)

        this.processQuantityUpdate(newQuantity)
    }

    processQuantityUpdate(quantity) {
        this.inputTarget.value = quantity
        this.inputTarget.dispatchEvent(new Event('change', { bubbles: true }))
        this.updateButtons(quantity)
    }

    updateButtons(quantity) {
        if (parseFloat(quantity) === parseFloat(this.inputTarget.max)) {
            this.increaseTarget.classList.add('disabled')
        } else {
            this.increaseTarget.classList.remove('disabled')
        }

        if (parseFloat(quantity) === parseFloat(this.inputTarget.min)) {
            this.decreaseTarget.classList.add('disabled')
        } else {
            this.decreaseTarget.classList.remove('disabled')
        }
    }

    reset(e) {
        e.preventDefault()
        this.processQuantityUpdate(this.inputTarget.dataset.initialValue)
    }

}